exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.scrollableArea {\n  display: -ms-flexbox;\n  display: flex;\n  height: 94vh;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.scrollableArea .scrollThis {\n    overflow: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2451a2ac","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/NewReservation/Availability.vue
// module id = 2847
// module chunks = 0